import { EventTypes } from './event-type.enum';

export interface ToastEvent {
  type: EventTypes;
  message: string;
  delay?: number | undefined;
}
